define(["require", "exports", "tslib", "mobx", "../EntityBase"], function (require, exports, tslib_1, mobx_1, EntityBase_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.DashboardParameters = void 0;
    class DashboardParameters extends EntityBase_1.Entity {
        constructor(entity = null, parent = null) {
            super();
            Object.defineProperty(this, "IncludeFacilityInsp", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "IncludeFacilityInspError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "IncludeFacilityWorksProjects", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "IncludeFacilityWorksProjectsError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "IncludeFacilityWpPr", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "IncludeFacilityWpPrError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "IncludePermits", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "IncludePermitsError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "IncludeSrnCr", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "IncludeSrnCrError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "IncludeWaterAgreements", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "IncludeWaterAgreementsError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            (0, mobx_1.makeObservable)(this);
            this.init(entity, parent, DashboardParameters.ObservableFields);
        }
        onCreate() {
            this.PersistanceState = EntityBase_1.PersistanceStates.NEW_RECORD;
        }
        onRead(entity) {
            if (entity.IncludeFacilityInsp) {
                this.IncludeFacilityInsp = entity.IncludeFacilityInsp;
            }
            if (entity.IncludeFacilityWorksProjects) {
                this.IncludeFacilityWorksProjects = entity.IncludeFacilityWorksProjects;
            }
            if (entity.IncludeFacilityWpPr) {
                this.IncludeFacilityWpPr = entity.IncludeFacilityWpPr;
            }
            if (entity.IncludePermits) {
                this.IncludePermits = entity.IncludePermits;
            }
            if (entity.IncludeSrnCr) {
                this.IncludeSrnCr = entity.IncludeSrnCr;
            }
            if (entity.IncludeWaterAgreements) {
                this.IncludeWaterAgreements = entity.IncludeWaterAgreements;
            }
        }
        onReady() {
        }
        merge(entity) {
            let a = this;
            let b = entity;
            if (!a || !b)
                throw new Error(`${this.constructor.name}.merge() expected a and b to be defined`);
            a.IncludeFacilityInsp = b.IncludeFacilityInsp;
            a.IncludeFacilityWorksProjects = b.IncludeFacilityWorksProjects;
            a.IncludeFacilityWpPr = b.IncludeFacilityWpPr;
            a.IncludePermits = b.IncludePermits;
            a.IncludeSrnCr = b.IncludeSrnCr;
            a.IncludeWaterAgreements = b.IncludeWaterAgreements;
            this.postMerge();
        }
        postMerge() {
        }
        serialise() {
            return JSON.stringify(this);
        }
        hasChanges() {
            return this.PersistanceState != EntityBase_1.PersistanceStates.EXISTING_UNMODIFIED;
        }
        validate() {
            return null;
        }
        toJson() {
            return {
                IncludeFacilityInsp: this.IncludeFacilityInsp,
                IncludeFacilityWorksProjects: this.IncludeFacilityWorksProjects,
                IncludeFacilityWpPr: this.IncludeFacilityWpPr,
                IncludePermits: this.IncludePermits,
                IncludeSrnCr: this.IncludeSrnCr,
                IncludeWaterAgreements: this.IncludeWaterAgreements,
                PersistanceState: this.PersistanceState,
                SecurityAccessLevel: this.SecurityAccessLevel
            };
        }
    }
    exports.DashboardParameters = DashboardParameters;
    Object.defineProperty(DashboardParameters, "ObservableFields", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: ["IncludeFacilityInsp", "IncludeFacilityWorksProjects", "IncludeFacilityWpPr", "IncludePermits", "IncludeSrnCr", "IncludeWaterAgreements"]
    });
    tslib_1.__decorate([
        mobx_1.observable
    ], DashboardParameters.prototype, "IncludeFacilityInsp", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], DashboardParameters.prototype, "IncludeFacilityInspError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], DashboardParameters.prototype, "IncludeFacilityWorksProjects", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], DashboardParameters.prototype, "IncludeFacilityWorksProjectsError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], DashboardParameters.prototype, "IncludeFacilityWpPr", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], DashboardParameters.prototype, "IncludeFacilityWpPrError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], DashboardParameters.prototype, "IncludePermits", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], DashboardParameters.prototype, "IncludePermitsError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], DashboardParameters.prototype, "IncludeSrnCr", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], DashboardParameters.prototype, "IncludeSrnCrError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], DashboardParameters.prototype, "IncludeWaterAgreements", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], DashboardParameters.prototype, "IncludeWaterAgreementsError", void 0);
});
